import { isWindowInIframe } from "./isInIframe";

export const notifyWorkspaceUrlUpdate = (url: string) => {
  if (!isWindowInIframe()) return;

  window.parent.postMessage(
    JSON.stringify({
      type: "URL_UPDATE",
      url,
    }),
    process.env.REACT_APP_PARENT_ORIGIN || "*",
  );
  localStorage.setItem("location_v2", url);
};
